import Vuex from 'vuex'
import Vue from 'vue'
import snackbar from './modules/snackbar'
import pageLoader from './modules/pageLoader'
import authModule from './modules/auth'
import assetModule from './modules/asset'
import userModule from './modules/user'
import channelModule from './modules/channel'
import mediaSourceModule from './modules/mediaSources'
import distributionModule from './modules/distributions'
import metadataModule from './modules/metadata'
import scheduleModule from './modules/schedule'
import sotalcloud from './modules/sotalcloud'
import uploadModule from './modules/upload'

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
  modules: {
    pageLoader,
    snackbar,
    users: userModule,
    auth: authModule,
    assets: assetModule,
    channels: channelModule,
    mediaSources: mediaSourceModule,
    distributions: distributionModule,
    metadata: metadataModule,
    schedule: scheduleModule,
    sotalcloud: sotalcloud,
    upload: uploadModule,
  },
})
